import { useCallback, useRef, useState } from 'react';
import { deviceDataApi } from '../api/device-data.api';
import { csvFileName, downloadText, readingsToCsv } from '../utils/csv';

export interface CsvDownload {
  download: () => void;
  downloading: boolean;
  /** Readings received so far while downloading. */
  progress: number;
  error?: unknown;
}

/** Fetches the device's whole history on demand and saves it as a CSV file. */
export const useCsvDownload = (uuid: string, name: string): CsvDownload => {
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState<unknown>();
  const busy = useRef(false);

  const download = useCallback(async () => {
    if (busy.current) return;
    busy.current = true;
    setDownloading(true);
    setProgress(0);
    setError(undefined);
    try {
      const readings = await deviceDataApi.getAll(uuid, setProgress);
      downloadText(readingsToCsv(uuid, readings), csvFileName(name, uuid));
    } catch (e) {
      setError(e);
    } finally {
      busy.current = false;
      setDownloading(false);
    }
  }, [uuid, name]);

  return { download, downloading, progress, error };
};
